export default {
    title: '三井塑料贸易（上海）有限公司',
    subTit: 'MITSUI PLASTICS TRADING (SHANGHAI) CO., LTD',
    head: {
        changeLang: 'JP',
    },
    home: {
        changeLang: 'JP',
    },
    pageTabbar: {
        tab1: 'ホーム',
        tab2: '企業情報',
        tab3: '主要取扱分野',
        tab4: '当社機能',
        tab5: '取扱商品',
        tab6: '在庫拠点',
        tab7: 'お問い合わせ',
    },
    index: {
        banner: {
            span1: '三井物産株式会社、三井物産（上海）貿易有限公司及び三井物産（中国）有限公司の共同出資により2003年に設立された外商投資企業。会社は中国（上海）自由貿易試験区に登録され、主に機能材料（合成樹脂原料、製品、無機化学工業品など）、先端材料（電子材料など）の輸出入、保税及び国内販売業務に従事している。',
            span2: '会社は三井物産グループの機能材料及び先端材料分野の中国販売センターとして、全国約30カ所の拠点に、さまざまなタイプの倉庫を持ち、各地の顧客に多様なJIT供給サービスを提供することができる。'
        },
        one: {
            span1: 'ABOUT US<br/><br/>',
            span2: '三井塑料貿易(上海)有限公司は三井物產株式会社、三井物產(上海)貿易有限公司、三井物産(中国)有限公司が共同出資して2003年に成立した外資系商社である。会社は中国(上海)自由貿易試験区に登録され、機能材料(合成樹脂原料、製品、无機化学品等)、先端材料(電子材料)等の販売を主業としている。会社は三井物産グル-プ100%出資、機能·先端材料領域の中国センタ-店として中国全土で約30か所の在庫拠点を保有し、全国各地の客先にJITサ-ビスを提供している。',
            span3: '2018年11月広州分公司を設立、当社機能(在庫、ディストリビュ-ション、マ-ケティンク等)の横展開により、中国華南地区の成長を取込んでいく。また、2019年6月南京事務所開設、同年7月蘇州事務所を開設、先端材料関連商内を中心に、江蘇省、安徽省、湖北省等長江中流地域の成長取込を加速させる。 三井塑料貿易(上海)有限公司は、中国全土における三井物産各拠点を初め、三井物産のグロ-バル販売ネットワ-ク及び総合力を活かし、当社の機能とサ-ビスを拡大し、中国経済成長と発展に貢献することを目指している。',
        },
        two: {
            span1: '主要取扱分野<br/><br/>',
            span2: '三井塑料貿易(上海)有限公司は三井物産グル-プ100%出資の子会社であり、機能材料(合成樹脂原料、製品、無機化学品等)、先端材料(電子材料)等の販売を主業としている。',
            span3: '<br/><br/>当社機能<br/><br/>',
            span4: 'トレ-ディング・与信機能、広域ネットワ-ク機能、マ-ケティング・販売力、ディストリビュ-ション・在庫機能。',

        },
        three: {
            span1: '取扱商品<br/><br/>',
            span2: '三井塑料(上海)貿易有限公司はエンジニアリングプラスチック、機能樹脂、ナイロンフィルム、クロロプレンゴム、酸化チタン、先端材料等の商品を取扱っている。',
            span3: '<br/><br/>在庫拠点<br/><br/>',
            span4: '三井塑料貿易(上海)有限公司は中国全域の18省・市に在庫拠点を保有している。顧客が満足する物流サ-ビスが 提供できる。',
        },
        gs: {
            title: 'グル-プネットワ-ク',
            gs1: '三井物産(中国)有限公司',
            gs2: '三井物産(中国)有限公司 東北分公司',
            gs3: '三井物産(中国)有限公司長春分公司',
            gs4: '三井物産(中国)有限公司 潘陽出張所',
            gs5: '三井物産(中国)有限公司 天津分公司',
            gs6: '三井物産(中国)有限公司 青島分公司',
            gs7: '三井物産(中国)有限公司 フフホト出張所',
            gs8: '三井物産(上海)贸易有限公司',
            gs9: '三井物产(上海)貿易有限公司 武漢分公司',
            gs10: '三井物座(上海)广易有限公司西南分公司',
            gs11: '三井物产(上海)貿易有限公司 西南分公司 成都出張所',
            gs12: '三井物産(広東)貿易有限公司',
            gs13: '三井物産(広東)贸易有限公司 長沙出張所',
            gs14: '三井物産(香港)有限公司',
        }
    },
    bottom: {
        title: 'お問い合わせ',
        company1: '三井塑料贸易(上海)有限公司',
        com1_span1: 'アドレス：上海市普陀区西康路1143号鴻寿坊東塔19階（〒200042）',
        com1_span2: '連絡電話：86(21)2223-6666',
        com1_span3: 'ファクシミリ：86(21)2223-6699',
        com1_span4: "メールボックス：PlanningSHMPS{'@'}dg.mitsui.com",
        company2: '三井塑料貿易(上海)有限公司広州分公司',
        com2_span1: 'ファクシミリ：广州市天河区天河路230号万菱国际中心3601室',
        com2_span2: '連絡電話：020-2887-0288',
        com2_span3: 'ファクシミリ：020-2887-0299',

        
        company3: '三井塑料贸易（上海）有限公司南京分公司',
        com3_span1: 'アドレス：南京市漢中路2号金陵飯店亜太商務中心8階890号室(〒210005)',
        com3_span2: '連絡電話：13472511541',
        company4: '三井塑料贸易（上海）有限公司蘇州事务所',
        com4_span1: 'アドレス：蘇州市蘇州工業園区華池路88号星合広場１座30階3016室(〒215021)',
        com4_span2: '連絡電話：13472519247',
        com4_span3: '連絡電話：(0512)6762-8868',

        botSpan1: 'COPYRIGHT 2003-2017 MITSUI PLASTICS TRADING (SHANGHAI) CO., LTD.ALL ',
        botSpan2: 'RIGHTS RESERVED 沪ICP备12001177号-1',
        botSpan3: '沪公网安备 31010702007338号',
        botSpan4: '沪(浦)应急管危经许[2023]203699',
    },
    company: {
        title1: '会社概要',
        line1_1_1: '会社名(中文)',
        line1_1_2: '三井塑料貿易(上海)有限公司',
        line1_2_1: '会社名(英文)',
        line1_2_2: 'Mitsui Plastics Trading Shanghai Co., Ltd.',
        line1_3_1: '本社住所',
        line1_3_2: '上海市普陀区西康路1143号鴻寿坊東塔19階（〒200042）',
        line1_4_1: '本社登記場所',
        line1_4_2: '中国(上海）自由貿易試験区基隆路6号外高橋大厦10階1006室',
        line1_5_1: '事業内容',
        line1_5_2: '機能材料（合成樹脂原料、製品、無機化学品等）、先端材料（電子材料）等の輸出入・三国間・保税・国内取引販売',
        line1_6_1: '登録資本金',
        line1_6_2: '30万米ドル',
        line1_7_1: '設立',
        line1_7_2: '2003年3月',
        line1_8_1: '株主',
        line1_8_2: '三井物産株式会社(80%)，三井物産(中国)有限公司(10%)，三井物産(上海)貿易有限公司(10%)',
        line1_9_1: '董事長・総経理',
        line1_9_2: '伊谷良太',
        title2: '沿革',
        line2_1_1: '2003年3月',
        line2_1_2: '三井塑料貿易(上海)有限公司(MPTS)設立（保税区現法。三井物産株式会社80%、三井物産(中国）有限公司10%、三井物産(上海）貿易有限公司10 %）',
        line2_2_1: '2004年1月',
        line2_2_2: '蘇州三井国際物流貿易有限公司(MILT)設立（外商投資物流試点企業。蘇州物流中心50%、三井物産株式会社40%、三井物産(中国)有限公司10 %) ',
        line2_3_1: '2007年1月',
        line2_3_2: '事業譲渡によるMPTSとMILTの統合。統合会社/三井塑料貿易(上海)有限公司(MPTS)。',
        line2_4_1: '2018年11月',
        line2_4_2: '広州分公司設立',
        line2_5_1: '2019年6月',
        line2_5_2: '南京事務所設立',
        line2_6_1: '2019年7月',
        line2_6_2: '蘇州事務所設立',
        line2_7_1: '2022年12月',
        line2_7_2: '南京分公司設立',
        title3: 'MPTSの拠点',
        line3_1_1: '本社',
        line3_1_2: '上海市普陀区西康路1143号鴻寿坊東塔19階（〒200042）',
        line3_1_3: 'Tel. +86-21-2223-6666',
        line3_1_4: '地下鉄7号線「长寿路」駅直結',
        line3_2_1: '広州分公司',
        line3_2_2: '広州市天河区天河路230号萬菱国際中心3601室(〒510620)',
        line3_2_3: 'Tel.+86-20-2887-0288',
        line3_3_1: '蘇州事務所',
        line3_3_2: '蘇州市蘇州工業園区華池路88号星合広場１座30階3016室(〒215021)',
        line3_3_3: 'Tel.+86-512-6762-8828',
        line3_4_1: '南京分公司',
        line3_4_2: '南京市漢中路2号金陵飯店亜太商務中心8階890号室(〒210005)',
        line3_4_3: 'Tel. +86-134-7251-1541',
    },
    main: {
        main: {
            tit: '三井塑料贸易(上海)有限公司',
            span1: '三井物産グルレ-プ100%出資',
            span2: '素材Distributor',
        },
        item1: {
            tit: 'インフラ',
            text: '太陽光·風力闃連素材、塩ビ樹脂、及び強化剂各種窓枠用途強化剂·塗料用原料 etc.'
        },
        item2: {
            tit: 'OA·家電',
            text: '高機能樹脂(Iンプラ、PS/ABS及び改質剂)携带電話·自動車内装向け塗料PCR etc.'
        },
        item3: {
            tit: '自動車',
            text: 'PPコンバウンド高機能樹脂(エンプラ各種)合成ゴム·Iラストマ-PCR etc'
        },
        item4: {
            tit: '包装材料',
            text: 'LLDPE、高機能フイルム、PCR紙製品、ウッドチップ etc.'
        },
        item5: {
            tit: '塗料·インキ',
            text: '酸化チタン チタン鉱石'
        },
        item6: {
            tit: '情報·電子',
            text: '絶縁フ厶、銅箔(回路基板材料) 放熟材料(放熟シ-ト·樹脂) デイスプレイ関連素材・フイルム 有機EL材料'
        },
        item7: {
            tit: '産業機械',
            text: '電動工具、建設機械関連素材 etc.'
        },
    },
    functions: {
        item1: {
            tit: 'トレ-ディング·与信機能',
            span1: '登録販売先:4,288社',
            span2: '登録仕入先:667社(23年10月)',
            span3: '· 様々な金融機能発揮',
            span4: '· 信用リスク·為替リスクに対応',
            span5: '· 資金需要二-ズに対応',
        },
        item2: {
            tit: 'ディストリビコ-ション・在庫機能',
            span1: '· 中国全土33か所の在庫拠点',
            span2: '· 保税区·輸出加工区等の在庫オベレ-ション',
            span3: '· 当社需要予測に基いた受発注·在庫管理によるリ-ドタイム短縮、納期短縮、安定供給',
            span4: '· 自動車·家電·OA·電子部品メ-カ一向けJT配送',
        },
        item3: {
            tit: '広域ネットワ-ク機能',
            span1: '· 中国内外の三井物産海外法人との協業',
            span2: '· 商品贩売戰略共有',
            span3: '· 新規サプライソ-スの提案',
        },
        item4: {
            tit: 'マ-ケティング·販売機能',
            span1: '· 約90名の営業部門スタツフ',
            span2: '· 継続的新規ビジネス取組',
            span3: '· 多様な産業のエンドユ-ザ-∧のアプロ-チ·刺さり込み',
            span4: '· 代理店的マ-ケティング',
        },
    },
    products: {
        tit1: '室别',
        tit2: '商品',
        tit3: '業界',
        tit4: '用途',

        line1_1: '消費財&電気材料',
        line1_2: '合成樹脂，(PP,PB,PC,PBTABS,POM.PA,PPS,PPA,LCP,PES,TPX.PEEK.TPUなど),ガラスフアイバ-,MB',
        line1_3: '自動車,OA機械, 電機道具,家電、電気設備',
        line1_4: '自動車部品，パイプ、携帯電話、力メラ, フィルム, 家電部品',

        line2_1: '産業材料',
        line2_2: '合成樹脂(PBT,PA,PA9T,PC,PPE,PBAT,TPUなど)',
        line2_3: '自動車,電子電気など',
        line2_4: 'コネクタ一，センサ一など,モ一タ一，断路器，继電器，スイッチなど',

        line3_1: 'エンプラ',
        line3_2: 'PC、PBT、ABS,POM、PA、PPS,LCP、PES、塗料、TPU',
        line3_3: '汽车, OA机器, 家电、电子设备自動車、OA機器,家電·電気電子',
        line3_4: '精密·自動車部品,携带電話塗料',

        line4_1: '工業樹脂',
        line4_2: 'PPコンパウンド、熱可塑性樹脂、エンプラ樹脂(ASA、PC/ ABS), 信越シリコ- ン、導電助剤',
        line4_3: '自動車、家電,自動車',
        line4_4: '内·外装部品，電池部品、リアクトル部品',

        line5_1: 'エラストマ 一',
        line5_2: 'クロロプレンゴム、EPDM、各種合成ゴム,ガラスコ-ド,ゴム添加剤',
        line5_3: '自働車、一般産業, 接着剤',
        line5_4: '自動車·工業用ゴム部品，接着剤',

        line6_1: 'フィルム材料',
        line6_2: 'バリア-フィルム、PEフイルム、生分解フイルム、PE樹脂、POE樹脂、EVA樹脂、TPU樹脂,PPA、添加剤',
        line6_3: '印刷加工,フィルムメ- 力 -，助剤',
        line6_4: '食品包装、工業包装,機能フィルム、ソ -ラ-材料、PPF材料.食品包装',

        line7_1: '生活資材',
        line7_2: 'ウッドチップ、紙製品,木製品(製材、原木、MDF、ParticleBoardなど),ガラス、真空断熱材,再生樹脂(再生PP、PE、PS、ABSペレットなど)',
        line7_3: '製紙、アパレル、食品、建築、インテリア家雷製造業、自動車、家電、OA、一般消費財、食品',
        line7_4: '印刷用纸、生活用紙、工業用紙、人造繊維, 食品用パッケ- ジなどの紙製品、再生セル口- ス(レ一ョン)，土木建築基材、内装補強材.家具, 家電部品，(自動車、家電、OA機器)部品、(消费財、食品)包装',

        line8_1: '機能性化学品',
        line8_2: '酸化チタン、シリコ-ン、ハイャ-オレフィン及びパラフィン類(アルフアオレフィン、ジイソ プチレン、イソ パラフィン等)、油脂化学製品(脂肪酸、グリセリン),MSポリマ-、シ-ラント用添加剤、ヨ-ド、カオリン他',
        line8_3: '塗料、インキ、コンパウンド、潤滑油、金属加工油、添加剤、化粧品, ゴム成型、フィル5シ-ラント、接着剤、電子、重合、タイヤ他',
        line8_4: '塗料、インキ、コンパウンド、潤滑油添加剤、工業潤滑油、タイヤ向け粘着付与剤、化粧品,自動車·家電部品、離型フィルム、工業·建築用シ- ラント、電子部品他',

        line9_1: '綜合添加剤',
        line9_2: '樹脂改質剤(MBS、ACR、難燃剤、AB剤、滑り剤、耐摩擦剤、透明結晶核剤など),工ポキシ強化剤,エペランEPP、PVCペ-スト、PC樹脂など',
        line9_3: 'コンパウンド、樹脂成型,風力発電、自動車,自動車、コンパウン ド',
        line9_4: 'コンパウンド、樹脂成型，接着剤、コンポジット材料,サンバイザ-、通い箱、手袋、コンパウンド',

        line10_1: '電子材料',
        line10_2: '絶縁フィルム、銅箔、放熱材料、有機EL材料,ディスプレイパネル、産業用フィルム材料、',
        line10_3: '回路基板、ディスプレイ，パネル(FPD、OLED) ',
        line10_4: 'スマ-トフオン、TV、産業用フィルム',

        line11_1: '新事業開発',
        line11_2: 'キャパシタPPフィルム及び原料,チップ低温実装,離型フィルム(PE / PET) ',
        line11_3: 'モビリティ,半導体',
        line11_4: '新工ネルギ一車,電子部品',


        line12_1: '広州機能材料',
        line12_2: '(機能材料)PVC、、メタ口センPE樹脂、汎用PE樹脂、POE樹脂、CR(クロロプレン・ゴム)、工ンプラ樹脂(PC他)、NVH対応材料(自動車減震材)等。(先端材料)PIフィルム、铜箔、離形フィルム、 離型紙等。',
        line12_3: 'フイルム、之-hンパウンド、自動事、ゴム成型、回路基板印刷、総合コンバ-タ等。',
        line12_4: '食品包材、工業包装、自動車·家電工業部品、スマ一フオン、衛生材料、電線ケ-プル,、接着剂、生活消費材他。',
    },
    stock: {
        tit1: 'No.',
        tit2: '地域',
        tit3: '在庫種類',

        area1: '上海地域',
        area2: '華東',
        area3: '遠隔地',

        hz: '杭州',
        //ks: '昆山',
        sz: '蘇州',
       // tc: '太倉',
        nb: '寧波',
        nt: '南通',
        zjg: '张家港',
       
        tj: '天津',
        dl: '大連',
        qd: '青岛',   
        sy: '瀋陽',
        cc: '長春',
        wh: '武漢',
        cq: '重慶',
        cd: '成都',
        xm: '厦門',
        gz: '広州',
        dw: '東莞',
        shz: '深セン',

        bsq: '保税区',
        bswlyq: '保税物流園区',
        yb: '一般',
        wxp: '危険品',
        ckjgq: '輸出加工区',
        c1: '（1箇所）',
        c2: '（0箇所）',
        c3: '（1箇所）',
        c5: '（5箇所）',
        c6: '（6箇所）',
    },
    contact: {
        title: '三井塑料貿易(上海)有限公司へのお間い合わせは下記からお寄せください',
    }
}